import type { Dispatch, SetStateAction } from 'react';

import service from '@/services/index';
import useFilterItemsStore from '@/stores/FilterItemsStore';
import { ReanalyzeStatus } from '@/types/filterItems';

import FilterItemsText from './FilterItemsText';

type FilterItemsAnalysisTextTabProps = {
  setHasTextTabChange: Dispatch<SetStateAction<boolean>>;
};

const FilterItemsAnalysisTextTab = (props: FilterItemsAnalysisTextTabProps) => {
  const { reanalyzeStatus, startReanalyze } = useFilterItemsStore();
  const onSaveChange = async (addedTexts: string[], deletedTexts: string[]) => {
    try {
      const data = await service.filterItems.changeAnalysisFilterTexts({
        added_texts: addedTexts,
        deleted_texts: deletedTexts,
      });

      startReanalyze();

      return data;
    } catch (error) {
      throw error;
    }
  };
  const editDisabled =
    reanalyzeStatus === ReanalyzeStatus.REANALYZE_STATUS_RUNNING;

  return (
    <FilterItemsText
      setHasTextTabChange={props.setHasTextTabChange}
      onSaveChange={onSaveChange}
      editDisabled={editDisabled}
    />
  );
};

export default FilterItemsAnalysisTextTab;
